import { useOrganizationStore } from '@/store/organization';
import { computed, ComputedRef } from 'vue';

export default function useImpersonation(): ComputedRef<string> {
  const organizationStore = useOrganizationStore();
  return computed(
    () => organizationStore.organizationImpersonation || organizationStore.organization?.organization || '',
  );
}
